<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-01-20                                                         -
  ----------------------------------------------------------------------------->

<template>
  <div class="d-flex justify-content-between align-items-baseline">
    <slot name="enums"></slot>
  </div>
</template>

<script>
export default {
  name: "yega1-query-interface",
  inject: {
    queryChanged: 'queryChanged'
  },
  provide() {
    return {
      addEnum: this.addEnum,
      querySelectionChanged: this.querySelectionChanged,
      querySelectionRemoved: this.querySelectionRemoved
    };
  },
  props:{
    queryObjectName:{
      type:String
    }
  },
  data() {
    return {
      queryObject: {},
      enums:[]
    };
  },
  computed:{
    data_source_query(){
      if(this.queryObjectName){
        let result = {};
        result[this.queryObjectName] = this.queryObject;
        return result;
      }else{
        return this.queryObject;
      }
    }
  },
  methods: {
    addEnum(enumVal){
      this.enums.push(enumVal);
    },
    querySelectionChanged(key,value){
      this.queryObject[key] = value;
      this.queryChanged(this.data_source_query);
    },
    querySelectionRemoved(key){
      delete this.queryObject[key];
      this.queryChanged(this.data_source_query);
    }
  }
}
</script>

<style scoped>

</style>
